import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la'
import { laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="latino"
      //REMOVED: univision_removed video and annotations
      // video={videos.latino.videoUrl}
      // annotations={videos.latino.annotations}
      //REPLACED: univision_removed poster images
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
      title="Save big on live TV for your family"
      subtitle={
        <>
          Access now for only <span className="green-underline">${laDiscountPriceMonthly}</span> the
          first month
        </>
      }
      networkSet="entertainmentLatino"
      noteLink="/la/ent-es/"
    />
  )
}
